import { Breadcrumbs, Link, Typography, Stack, TablePagination } from "@mui/material";
import { BackButton } from "../../../../../common/components/back_button";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { Link as LinkTo } from "react-router";
import { useMaquinasEquipItensVerificacaoViewModel } from "../../viewModels/maquinas_equip_itens_verificacao_view_model";
import { FormRadioGroupInput } from "../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { DefaultFormAutocomplete } from "../../../../../common/components/default_form_autocomplete";
import { DefaultFormDatePickerInput } from "../../../../../common/components/default_form_date_picker_input";
import { useMemo } from "react";
import { GenerateItensInspecaoColumnDefs } from "./columns";
import { DefaultFormFileInput } from "../../../../../common/components/default_form_file_input";
import { DefaultDatePicker } from "../../../../../common/components/masked_inputs/default_date_picker_input";
import { InspecaoMaquinaEquipItemLista } from "../../../domain/models/inspecao_maquina_equip_item_lista";
import { isValidId } from "../../../../../common/utils/utils";

import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import BottomBar from "../../../../../common/components/bottom_bar";
import RefreshButton from "../../../../../common/components/refresh_button";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import DefaultInput from "../../../../../common/components/default_input";
import { LegendComponent } from "../../../../../common/components/legend_component";
import { LegendTagIcon } from "../../../../../common/components/legend_tag_icon";
import { LegendTagItemComponent } from "../../../../../common/components/legend_tag_item_component";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";

/**
 * MaquinasEquipItensVerificacao
 */

export const MaquinasEquipItensVerificacao = () => {
  const viewModel = useMaquinasEquipItensVerificacaoViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateItensInspecaoColumnDefs({
      onActionInspecao1Change: viewModel.handleChangeInspecao1,
      onActionInspecao2Change: viewModel.handleChangeInspecao2,
    });
  }, [
    viewModel.handleChangeInspecao1,
    viewModel.handleChangeInspecao2,
  ]);

  return (
    <>
      <form onSubmit={viewModel.handleInspecaoMaquinasEquipSubmit}>
        <PageTopBar>
          <ThreeSlotLayout
            rightSlot={
              <div className="flex flex-row gap-2">
                <BackButton onClick={() => viewModel.handleBack()} />
              </div>
            }
          />
        </PageTopBar>

        <div className="flex w-full gap-6 flex-col px-10 mb-8 pt-8">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Controle de Patrimônio
            </Link>
            <Link underline="hover" color="inherit" component={"span"}>
              <LinkTo to="/MaquinasEquip_controle">Controle</LinkTo>
            </Link>
            <Typography className="text-primary-green">Inspeção de Máquinas e Equipamentos Inspeção de Itens</Typography>
          </Breadcrumbs>
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">Inspeção de Máquinas e Equipamentos</h1>
            <RefreshButton onClick={() => viewModel.handleReload()} />
          </div>
        </div>

        <div className="flex w-full flex-col px-10 mb-8 gap-4">
          <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4 gap-4 flex flex-col gap-2">
            {
              viewModel.inspecaoMaquinaEquip &&
              <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 text-black dark:text-white">
                <DefaultInput
                  name='centroCusto'
                  label='Centro de custo'
                  readOnly={true}
                  value={viewModel.inspecaoMaquinaEquip.centroCusto}
                />

                <DefaultInput
                  name='maquinaEquipamento'
                  label='Máquina/Equipamento'
                  readOnly={true}
                  value={viewModel.inspecaoMaquinaEquip.maquinaEquip}
                />

                <DefaultDatePicker
                  name='dataInspecao'
                  label='Data da inspeção'
                  readOnly={true}
                  value={viewModel.inspecaoMaquinaEquip.dataInspecao}
                  onChangeValue={() => { }}
                />
              </div>
            }
          </div>

          <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4 gap-4 flex flex-col gap-2">
            <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4">
              <DefaultFormAutocomplete
                name='idFuncionarioInspecionado'
                label='Inspecionado por?'
                readOnly={viewModel.inspecaoMaquinaEquip !== null && viewModel.inspecaoMaquinaEquip.status === 1}
                getOptionDisabled={x => !x.canBeSelected}
                getOptionKey={x => x.idFuncionario}
                getOptionLabel={x => x.nome}
                options={viewModel.funcionariosInspecionadoDropdown}
                reactHookForm={viewModel.hookForm}
              />

              <DefaultFormAutocomplete
                name='idFuncionarioAprovado'
                label='Aprovado por?'
                readOnly={viewModel.inspecaoMaquinaEquip !== null && viewModel.inspecaoMaquinaEquip.status === 1}
                getOptionDisabled={x => !x.canBeSelected}
                getOptionKey={x => x.idFuncionario}
                getOptionLabel={x => x.nome}
                options={viewModel.funcionariosAprovadoDropdown}
                reactHookForm={viewModel.hookForm}
              />

              <FormRadioGroupInput
                name="status"
                label="Status"
                options={viewModel.statusOptions}
                reactHookForm={viewModel.hookForm}
              />

              <DefaultFormDatePickerInput
                name="dataEncerramento"
                label="Data Encerramento"
                reactHookForm={viewModel.hookForm}
              />
            </div>
          </div>

          {/* Tabela de Itens */}

          <Stack spacing={0}>
            <LegendComponent>
              <LegendTagItemComponent
                icon={<LegendTagIcon color='blue-light' title='NA' />}
                label='Não Se Aplica'
              />

              <LegendTagItemComponent
                icon={<LegendTagIcon color='green' title='A' />}
                label='Aprovada'
              />

              <LegendTagItemComponent
                icon={<LegendTagIcon color='red' title='C' />}
                label='Corretiva'
              />

              <LegendTagItemComponent
                icon={<LegendTagIcon color='yellow' title='P' />}
                label='Preventiva'
              />

            </LegendComponent>

            <StyledDataGrid
              tableName="maquinas_equip_itens_verificacao"
              disableColumnMenu={false}
              getRowId={(row: InspecaoMaquinaEquipItemLista) => row.idInspecaoMaquinaEquipItens}
              columns={columnsDefinition}
              loading={viewModel.loading}
              rows={viewModel.inspecaoMaquinaEquipItens}
              rowCount={viewModel.inspecaoMaquinaEquipItens.length}
              pageSizeOptions={[10, 25, 50, 100]}
              paginationMode="server"
              paginationModel={{
                page: viewModel.pagination.page,
                pageSize: viewModel.pagination.rowsPerPage,
              }}
            />

            <TablePagination
              component="div"
              count={viewModel.pagination.totalItems}
              page={viewModel.pagination.page - 1}
              onPageChange={(_, p) => viewModel.handlePageChange(p)}
              rowsPerPageOptions={[10, 25, 50, 100]}
              rowsPerPage={viewModel.pagination.rowsPerPage}
              onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
            />
          </Stack>

          <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4 gap-4 flex flex-col">
            <DefaultFormInput
              name="descricaoProblema"
              label="Descrição do Problema"
              multiline={true}
              minRows={5}
              reactHookForm={viewModel.hookForm}
            />

            <DefaultFormInput
              name="correcaoProblema"
              label="Correção do Problema"
              multiline={true}
              minRows={5}
              reactHookForm={viewModel.hookForm}
            />
          </div>

          <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4 gap-4 flex flex-col">
            <h1 className="text-xl font-semibold text-black dark:text-white">Anexar Arquivos</h1>
            <div className="w-full flex flex-col gap-2">
              <DefaultFormFileInput
                name="arquivo1"
                maxFilenameLength={80}
                filename={viewModel.inspecaoMaquinaEquip?.nomearquivo1 ?? undefined}
                saving={viewModel.saving}
                loading={viewModel.loading}
                reactHookForm={viewModel.hookForm}
                onDownload={() => viewModel.handleInspecaoMaquinasEquipDownload(1)}
                onChangeFile={() => viewModel.hookForm.setValue('limparArquivo1', false)}
                onLimparArquivo={() => viewModel.handleInspecaoMaquinasEquipLimparArquivo(1)}
              />

              <DefaultFormFileInput
                name="arquivo2"
                maxFilenameLength={80}
                filename={viewModel.inspecaoMaquinaEquip?.nomearquivo2 ?? undefined}
                saving={viewModel.saving}
                loading={viewModel.loading}
                reactHookForm={viewModel.hookForm}
                onDownload={() => viewModel.handleInspecaoMaquinasEquipDownload(2)}
                onChangeFile={() => viewModel.hookForm.setValue('limparArquivo2', false)}
                onLimparArquivo={() => viewModel.handleInspecaoMaquinasEquipLimparArquivo(2)}
              />
            </div>
          </div>
        </div>

        {/**
          * Bottom bar
          */}

        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4">
            <div>
              {
                isValidId(viewModel.idInspecaoMaquinaEquip) &&
                <PrimaryButton
                  buttonColor="yellow"
                  onClick={() => viewModel.handleOpenChangeHistory(null, null)}>
                  <span className="text-xs">
                    Historico de alterações
                  </span>
                </PrimaryButton>
              }
            </div>

            <div className="flex flex-row gap-4">
              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1
                  className="text-sm text-black dark:text-white"
                  onClick={viewModel.handleBack}>
                  Cancelar
                </h1>
              </div>
              <div className="w-[130px]">
                {viewModel.saving
                  ? (
                    <PrimaryButton>
                      Salvando...
                    </PrimaryButton>
                  ) : (
                    <PrimaryButton
                      type="submit"
                      startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                      Salvar
                    </PrimaryButton>
                  )}
              </div>
            </div>
          </div>
        </BottomBar>
      </form>

      {/**
        * Modals
        */}

      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />
    </>
  );
};
